import { logisticsAsset, logisticsSafety, manufacturingSteel } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '매년 수백만 건의 노동 사고가 적절한 보호 조치 부족으로 발생하고 있다는 사실을 알고 계신가요? 안전관리는 단순한 용어가 아니라, 사람을 보호하고 업무 효율성을 높이는 핵심입니다. 노동 사고나 심각한 문제는 인명과 재산에 큰 손실을 초래할 뿐만 아니라 기업의 신뢰도에 부정적인 영향을 미칩니다. 이 글에서는 안전관리의 개념을 설명하고, 보다 안전한 근무 환경을 구축하기 위한 실질적인 방법을 제시합니다.',
  keywords: '안전관리, 안전관리 시스템, RTLS, 생산에서의 안전관리',
  ogSite: '안전관리란 무엇인가? 안전관리를 보장하는 방법은?',
  title: '안전관리란 무엇인가? 안전관리를 보장하는 방법은?',
  ogUrl: 'https://orbro.io/blog/occupationalSafety',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_EgEFbhMtWiEwNyMDjT_kdBK870NbSj_bNrZ9swqJG46pjGpb5N1vJQEASWWupgT-v93cWSpyF2zCC97zWHRr46O4Q3PdBsu8PA8QS5Ukbr7KQuOs8hBr-bpc6khRLMQ5PG3nnhPtk1_E8xsyrUTfmt_mLDGuPBy6D0yS8__WS_COmt8biDtSxxF5zxlHk1ZQXTme2VS18H4ZF2eRaHUTAJM_7K2zGe1zAxX4Dah4WxAp5i5XcoPgL44nGnpD4W5sSuMFK-OmaN2QbecHSb3AagbRppK0OM2lUZY7Fp7s2cysOqJTrHLKlvntvvDzrSM2JFMs9wDZ0nTytId6cmXCjNWASeskj_nFppMg9WNBRjZxgQTc6ZPka9k0y8ruDaAHOJnwk1nbKd1M8ZgloLJTmS0uq3e2XNTts9S3xyebpDg5Mxr2BDR_-kl_jrnijiFGUJ8Wy1gKdCOhw1gEXCbH-Zw_uLFNniY2C7uRnEwHUZBn9vWYWL0BlSws2HDypWnK3CeNk9R_i9g6rMDFTTY2chUh4dcqmyHa2jbQqmx3ee7wE8MtNxPCyKtYNWG6L4GHt-LDWbKCyJe77ZM-OQRm4HerU3CN7qSgTx1V7FgtR1QTps4CpK7sytay2vFH3ZShm-R8vr9LtXEQB-D8iGvDxznq42PZpEfBKtJGVQy6j3mg8ltvhtYcHT_oBVzOJHXMSaFZhSHCMW6x0zLFAWqFeafCxsFLH7cHdsqjTOXk4CAMOBazIpI7Q10g6EAQOG4RU-q6_NS0ompSYSrujy4-fYLi09_8y-Ob_GbFVFYanTeOs1SUAzoEXJaIRKyNhKhGqBYwdrtrjA_-2v2Awi0RgE23EvuGOIwP0Xot0MmEfAhh8lFHMeHSh-C4IYufJ3850ioaFXMCo90oiHqkXkPEIh-oD5J4-hZTr__dtgf3DWQgjTSZPRimO3cHmy1h3fPxkNP0N3Dx4tPV9jsyqLNC8S1DLi2nfmUqKCan775uD45-QpeVqP9X28LOCoJXp5u8s1NTFzK3nEf_sAStWLWhcdAXK8eb9oWzPpw5BRh8tYFLul-bJxnP5SX-HlvZ4OHu_YfxUSEMmVACxWb9CT6qn7ifv1sFabOGcLCS4bYXzcFTB8NL1xVkryVmptHJfLoWjccqObUJBxA_3EJxH_-eDejyS7sHo9Ny4ygPjT3HXn7IWRp4c60vCjjiMkLpkDhQ9qRkU8wDT91NJGesVc-XMacxEAPZlrTY2lfg_alEnmYNntmg4-jKYRWG13-TCGApSebI34fx5jgPeIPLSxEiZtdZrz_pOgd6MDaNqjLWPle7nnUzVKvwoBnaApoEPUAf3tFvd01RCpgIXGnk_9m7tiKp9GxqgR67b1WD14j5_846Dh1h7NrcaOTDiQmlenQKwMmPV_zaqS95IBnyfbmQKe6W6qsbA_vZ13RlDcHafEvVHxU2gberGByqAyfsN4Wxn_SC0KPHa8mHcFYUWS-jk6J36xechKAqAag3HrRI-KHs5q3UP9zd9NMdfLG5ANOX8F5icyzbSHnOZsG3wILjPBCDRif1ifxqVJn3Fhb4CCN_vHBfnaysSoOY7uQ0U8agwhZFj8KQPlTtbuOcFA_zaXKpaddpI7siFndJD4oQ=w1406-h1450?auditContext=prefetch',
  ogType: 'website',
  date: '2025-07-07',
  tag1: '#안전관리',
  tag2: '#안전관리 시스템',
  tag3: '#RTLS',
  tag4: '#생산에서의안전관리',
  text: [
    {
      head: '',
      subHead: '',
      desc: '매년 수백만 건의 노동 사고가 적절한 보호 조치 부족으로 발생하고 있다는 사실을 알고 계신가요? 안전관리는 단순한 용어가 아니라, 사람을 보호하고 업무 효율성을 높이는 핵심입니다. 노동 사고나 심각한 문제는 인명과 재산에 큰 손실을 초래할 뿐만 아니라 기업의 신뢰도에 부정적인 영향을 미칩니다. 이 글에서는 안전관리의 개념을 설명하고, 보다 안전한 근무 환경을 구축하기 위한 실질적인 방법을 제시합니다.',
      dot: ''
    },
    {
      head: '1. 안전관리란 무엇인가?',
      subHead: '',
      desc: '안전관리는 근로자의 건강과 생명을 보호하기 위해 마련된 일련의 조치, 절차, 정책을 의미합니다. 이는 사고 예방, 위험 감소, 그리고 근무 환경이 안전 기준을 충족하도록 보장하는 것을 포함합니다. 안전관리의 목표는 사람을 보호하는 것뿐만 아니라, 사고로 인한 비용 절감, 생산성 향상, 기업 신뢰도 구축에 기여하는 것입니다.\n\n공장, 건설 현장, 사무실 등 모든 근무 환경에서 안전관리는 중요한 역할을 합니다. 이는 관리자의 책임일 뿐만 아니라, 모든 직원의 협력이 필요합니다.\n\n예시: 공장에서 안전관리는 근로자가 무거운 기계를 작동할 때 보호 장비를 착용하도\n록 보장하는 것입니다.',
      dot: ''
    },
    {
      head: '2. 안전관리가 중요한 이유는?',
      subHead: '',
      desc: '안전관리는 도덕적 책임뿐만 아니라 실질적인 이점을 제공합니다.\n\n인명 보호: 사고, 부상, 직업병을 줄여 근로자가 안심하고 일할 수 있도록 합니다.\n\n비용 절감: 보상, 장비 수리, 사고로 인한 생산 중단 비용을 줄입니다.\n\n생산성 향상: 안전한 환경은 근로자의 집중력을 높여 효율성을 개선합니다.\n\n법적 준수: 안전관리 규정을 준수하여 벌금이나 소송을 피할 수 있습니다.\n\n신뢰도 구축: 안전관리를 중시하는 기업은 직원과 고객에게 높은 평가를 받습니다.\n\n예시: 건설 회사가 안전관리에 투자하여 노동 사고를 30% 줄이고, 근로자들의 신뢰를 얻었습니다.',
      dot: ''
    },
    {
      head: '3. 노동 환경에서 흔히 발생하는 위험',
      subHead: '',
      desc: '안전관리를 보장하려면 흔히 발생하는 위험을 이해해야 합니다.\n\n물리적 사고: 높은 곳에서 떨어지거나, 기계와 충돌하거나, 장비에 끼이는 사고.\n\n위험 화학물질: 독성 가스, 인화성 액체, 유해 물질에 노출.\n\n환경적 요인: 극한 온도, 큰 소음, 장시간 진동.\n\n인적 오류: 교육 부족, 절차 미준수, 보호 장비 미착용.\n\n이러한 위험을 이해하는 것은 효과적인 안전관리 조치를 마련하는 첫 단계입니다.',
      dot: ''
    },
    {
      head: '4. 안전관리를 보장하는 방법',
      subHead: '',
      desc: '안전한 근무 환경을 조성하기 위해 기업과 근로자는 다음 조치를 적용해야 합니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '위험 평가 및 장비 유지보수',
      desc: '기계 및 장비 점검: 정기적으로 점검 및 유지보수를 통해 고장을 사전에 감지합니다.\n위험 분석 (Hazard Analysis): 잠재적 위험과 그 정도를 식별합니다.\n비상 대응 계획: 대피, 응급 처치, 사고 처리 절차를 준비합니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '교육 및 인식 제고',
      desc: '안전 교육: 안전 절차, 비상 상황 대처, 개인 보호 장비(PPE) 사용에 대한 교육을 실시하여 근로자가 위험을 인지하고 적절히 대응하도록 합니다.\n인식 제고 프로그램: 모의 훈련, 세미나, 경험 공유를 통해 근로자가 스스로 예방에 적극적으로 참여하도록 독려합니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '개인 보호 장비(PPE) 완비',
      desc: '보호 헬멧, 장갑, 정전기 방지 신발: 머리, 손, 발을 충격과 감전으로부터 보호합니다.\n보호 안경, 방독 마스크: 먼지, 독성 가스, 액체가 눈과 코로 들어가는 것을 방지합니다.\n반사 조끼, 안전 벨트: 근로자를 쉽게 식별하고 높은 곳에서의 추락을 방지합니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '안전 운용 절차 수립',
      desc: '표준 운용 절차(SOP): 작업 단계, 안전 한계, 경고를 상세히 기술합니다.\n절차 수립: 기계 운용, 화학물질 처리, 비상 탈출에 대한 명확한 규정을 마련합니다.',
      dot: ''
    },
    {
      head: '',
      subHead: 'RTLS 기술을 활용한 안전 감독',
      desc: 'RTLS(Real-Time Location System)는 근로자와 장비의 위치를 실시간으로 추적합니다.\n\n• 위험 구역 감독: 보호 헬멧이나 직원 배지에 태그를 부착하여, 근로자가 고위험 구역(예: 용광로, 화학물질 구역)에 들어가면 즉시 경고를 보냅니다.\n\n• 사고 즉시 감지: RTLS는 추락, 충돌 등 강한 충격을 감지하고 운영팀에 자동으로 알립니다.\n\n• 신속한 구조 지원: 사고 시 근로자의 위치를 파악하여 빠른 구조를 가능하게 합니다.\n\n• 작업 행동 분석: AI와 RTLS를 결합하여 이동 경로, 작업 시간을 분석하고, 위험을 줄이는 절차 개선을 제안합니다.\n\n• 자산 관리: 기계나 도구가 올바른 장소에서 사용되도록 보장하여 손실을 줄입니다.\n\n예시: 화학 공장이 RTLS를 사용하여 근로자가 독성 가스 구역에 접근하면 경고를 보내, 사고 위험을 40% 줄였습니다.',
      dot: ''
    },
    {
      head: '5. 체계적인 안전관리의 이점',
      subHead: '',
      desc: '사고 감소: 위험 관리 시스템과 RTLS가 사고를 사전에 경고하고 예방합니다.\n\n비용 절감: 보상, 유지보수, 예기치 않은 기계 중단 비용을 최소화합니다.\n\n생산성 향상: 안전한 환경은 근로자의 심리적 안정감을 주어 효율성을 높입니다.\n\n법적 규정 준수: 벌금을 피하고 기업 신뢰도를 높입니다.\n\n지속 가능한 발전: 안전관리 문화는 사회적 책임과 브랜드 가치를 강화합니다.',
      dot: ''
    },
    {
      head: '6. 안전관리의 실제 적용 사례',
      subHead: '',
      desc: '안전관리는 다양한 산업에서 적용되어 뚜렷한 효과를 발휘합니다.\n\n제조 및 산업\n적용: RTLS 및 보호 장비를 사용하여 화학 공장이나 제철소 근로자를 보호합니다.\n예시: 제철소가 RTLS를 도입하여 근로자가 용광로 근처에 접근하지 않도록 관리해 화상 사고를 줄였습니다.\n\n건설\n적용: 미끄럼 방지 신발, 안전 벨트 제공, 고소 작업 교육 실시.\n예시: 건설 현장이 안전 벨트와 비계 정기 점검사를 통해 추락 사고를 50% 줄였습니다.\n\n의료\n적용: 의료 폐기물 안전하게 처리하고, 환자와 접촉 시 장갑, 마스크 사용.\n예시: 병원이 RTLS를 사용하여 의료 장비(예: 인공호흡기)의 위치를 추적해 분실을 방지했습니다.\n\n운송 및 물류\n적용: 운전자 감독, 차량 점검을 통해 교통 사고를 예방.\n예시: 운송 회사가 GPS 추적과 RTLS를 결합하여 운전자가 위험 구역에 진입하지 않도록 관리했습니다.',
      dot: ''
    },
    {
      head: '7. 결론',
      subHead: '',
      desc: '안전관리는 단순한 책임이 아니라, 기업의 지속 가능한 발전과 근로자의 건강을 위한 투자입니다. 교육, 보호 장비, RTLS와 같은 첨단 기술까지, 모든 조치는 안전하고 효율적인 근무 환경을 만드는 데 기여합니다.\n\n지금 바로 안전관리 조치를 적용하여 팀을 보호할 준비가 되셨나요? 오늘부터 신뢰할 수 있고 강력한 근무 환경을 구축해 보세요!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/enterprise/logistics/asset',
      },
      {
        img: logisticsSafety.thumb,
        data: 'logisticsSafety',
        link: '/enterprise/logistics/safety',
      },
      {
        img: manufacturingSteel.thumb,
        data: 'manufacturingSteel',
        link: '/enterprise/manufacturing/steel',
      },
    ],
  },
};
